import Vue from 'vue';
import Router from 'vue-router';
import seekerRoutes from './seekerRoutes';
import providerRoutes from './providerRoutes';
import store from '../store';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: '/',
  routes: [...seekerRoutes, ...providerRoutes],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition; // Scroll to saved position
    }
    return { x: 0, y: 0 }; // Scroll to the top
  },
});

// global navigation guard to get account data
router.beforeEach(async (to, from, next) => {
  if (store.getters['account/getAccount'] === null) {
    try {
      await store.dispatch('account/fetchAccountData');
    } catch (error) {
      console.error('Failed to fetch account data', error);
      // redirect to login or show an error page
    }
  }
  next();
});

export default router;
